import { Paper, Stack, Typography } from '@mui/material';

/** Route stub. Replaced screen by screen as each phase lands. */
export function Placeholder({ title, phase }: { title: string; phase: string }) {
  return (
    <Stack spacing={2}>
      <Typography variant="h1">{title}</Typography>
      <Paper sx={{ p: 3 }}>
        <Typography color="text.secondary">
          {phase ? `Not built yet — scheduled for ${phase}.` : 'This page does not exist.'}
        </Typography>
      </Paper>
    </Stack>
  );
}
